export default "__VITE_ASSET__hmBhsvVr__"